import edu1_1 from '@/assets/images/home/edu/tab-1-1.png';
import edu1_2 from '@/assets/images/home/edu/tab-1-2.png';
import edu1_3 from '@/assets/images/home/edu/tab-1-3.png';

import edu2_1 from '@/assets/images/home/edu/tab-2-1.png';
import edu2_2 from '@/assets/images/home/edu/tab-2-2.png';
import edu2_3 from '@/assets/images/home/edu/tab-2-3.png';
import edu2_4 from '@/assets/images/home/edu/tab-2-4.png';

import edu3_1 from '@/assets/images/home/edu/tab-3-1.png';
import edu3_2 from '@/assets/images/home/edu/tab-3-2.png';
import edu3_3 from '@/assets/images/home/edu/tab-3-3.png';
import edu3_4 from '@/assets/images/home/edu/tab-3-4.png';

import ability1_1 from '@/assets/images/home/ability/tab-1-1.png';
import ability1_2 from '@/assets/images/home/ability/tab-1-2.png';
import ability1_3 from '@/assets/images/home/ability/tab-1-3.png';
import ability1_4 from '@/assets/images/home/ability/tab-1-4.png';

import ability2_1 from '@/assets/images/home/ability/tab-2-1.png';
import ability2_2 from '@/assets/images/home/ability/tab-2-2.png';
import ability2_3 from '@/assets/images/home/ability/tab-2-3.png';

import solve1_1 from '@/assets/images/home/solve/tab-1-1.png';
import solve1_2 from '@/assets/images/home/solve/tab-1-2.png';
import solve1_3 from '@/assets/images/home/solve/tab-1-3.png';

import secure_cloud from '@/assets/images/home/secure/cloud.png';
import secure_info from '@/assets/images/home/secure/info.png';
import secure_lock from '@/assets/images/home/secure/lock.png';
import secure_share from '@/assets/images/home/secure/share.png';

import ai1_1 from '@/assets/images/home/ai/tab-1-1.png';
import ai1_2 from '@/assets/images/home/ai/tab-1-2.png';
import ai1_3 from '@/assets/images/home/ai/tab-1-3.png';
import ai1_4 from '@/assets/images/home/ai/tab-1-4.png';

import service1_1 from '@/assets/images/home/service/tab1-1.png';
import service1_2 from '@/assets/images/home/service/tab1-2.png';
import service1_3 from '@/assets/images/home/service/tab1-3.png';

import bannerPng from '@/assets/images/home/banner-365.png';
import bannerPng2 from '@/assets/images/home/banner-solve.png';
import bannerLogoStart from '@/assets/images/logo-star.png';
import bannerLogo365 from '@/assets/images/logo-365.png';

export const bannerData365 = {
  title: '智慧教育新体验',
  subtitle: '一站式数智化解决方案平台，让AI提效每一步',
  buttonTxt: '下载教育版客户端',
  buttonTxtWeb: '前往电脑端下载使用',
  logo: bannerLogo365,
  bgImg: bannerPng,
  buttonEvent: 'banner_down_load',
};

export const bannerDataSolve = {
  title: 'WPS智慧教育平台',
  subtitle: '让每个学校都能在数智化建设的路上更进一步',
  buttonTxt: '咨询解决方案',
  buttonTxtWeb: '咨询解决方案',
  logo: bannerLogoStart,
  bgImg: bannerPng2,
  buttonEvent: 'banner_consult',
};

export const workData = {
  title: '一站式AI教学办公体验',
  subtitle: '文档、消息、会议、邮箱，所有工作都在一个位置',
  subtitleM: '文档、消息、会议、邮箱 <br/>所有工作都在一个位置',
  list: [
    {
      icon: 'LogoWpsLogoFlat',
      name: 'Office 文档',
      desc: '专业级文档处理',
    },
    {
      icon: 'ApFormat',
      name: '智能文档',
      desc: '智能文稿创作',
    },
    {
      icon: 'KsheetFormat',
      name: '智能表格',
      desc: '智能数据分析',
    },
    {
      icon: 'FormFormat',
      name: '智能表单',
      desc: '收集统计效率翻倍',
    },
    {
      icon: 'DbsFormat',
      name: '多维表格',
      desc: '快速搭建业务系统',
    },
    {
      icon: 'CloudLogo',
      name: 'WPS 云盘',
      desc: '安全的学校级存储',
    },
    {
      icon: 'WoaLogo',
      name: 'WPS 协作',
      desc: '校园内部高效沟通',
    },
    {
      icon: 'MeetingLogo',
      name: 'WPS 会议',
      desc: '沉浸式智能会议室',
    },
    {
      icon: 'MailLogo',
      name: 'WPS 邮箱',
      desc: '超轻量智能邮箱',
    },
    {
      icon: 'CalendarLogo',
      name: 'WPS 日历',
      desc: '智能时间管理利器',
    },
    {
      icon: 'TodoColorful',
      name: 'WPS 待办',
      desc: '高效直观待办管理',
    },
    {
      icon: 'AppsLogo',
      name: 'WPS 工作台',
      desc: '千人千面的办公门户',
    },
  ],
};

export const eduData = {
  title: '开启AI智慧校园',
  subtitle: '赋能教育智能升级，师生减负增效的密码',
  tabs: [
    {
      obj: [
        {
          title: '智能基座',
          sub: 'AI Hub',
          desc: '支持多个大模型切换，调用过程可审计追踪，实现业务高效智能，同时保障数据调用安全。',
          bigImg: edu1_1,
        },
        {
          title: '智能文档库',
          sub: 'AI Docs',
          desc: '云文档一键升级智能文档库，通过问答快速检索信息，并可根据学校知识智能创作文档。',
          bigImg: edu1_2,
        },
        {
          title: '智能助理',
          sub: 'Copilot Pro',
          desc: '通过对话即可高效处理数据，支持调用 WPS 365 API 和学校自有 API 执行各项任务。',
          bigImg: edu1_3,
        },
      ],
    },
    {
      obj: [
        {
          title: 'AI写作助手',
          desc: '教案伴写、材料总结、发言稿润色，无忧创作；论文、公文一键排版。',
          bigImg: edu2_1,
        },
        {
          title: 'AI数据助手',
          desc: '五育评价、学情分析、快速图表生成、AI写公式，玩转数据表格。',
          bigImg: edu2_2,
        },
        {
          title: 'AI设计助手',
          desc: '快速生成教案设计、主题班会、校园活动策划等场景PPT，单页美化，轻松高效。',
          bigImg: edu2_3,
        },
        {
          title: 'AI阅读助手',
          desc: '文献内容总结、沉浸式伴读、文献翻译，便捷提效。',
          bigImg: edu2_4,
        },
      ],
    },
    {
      obj: [
        {
          title: 'AI会议纪要',
          desc: '会议录音转文字、生成脑图/待办、会议内容问答，全面提升协作效能。',
          bigImg: edu3_1,
        },
        {
          title: 'AI智能备课',
          desc: '中小学教案、教学大纲、学案、PBL设计，智能提效。',
          bigImg: edu3_2,
        },
        {
          title: 'AI百宝箱',
          desc: '备课、教研、教务管理，一站式AI教育工具合集。',
          bigImg: edu3_3,
        },
        {
          title: 'AI实训平台',
          desc: '理论学习、技能实操、综合应用，助力中小学人工智能课程开展。',
          bigImg: edu3_4,
        },
      ],
    }
  ],
};

export const priceData = {
  title: '选择最合适的WPS 365 教育版本',
  titleM: '选择最合适的<br/>WPS 365 教育版本',
  subtitle: '所有版本均支持智能、简单、实用的产品能力',
  list: [
    {
      icon: 'LogoWpsLogoFlat',
      name: 'Office 文档',
    },
    {
      icon: 'ApFormat',
      name: '智能文档',
    },
    {
      icon: 'DbsFormat',
      name: '多维表格',
      desc: '快速搭建业务系统',
    },
    {
      icon: 'WoaLogo',
      name: 'WPS 协作',
      desc: '企业内部高效沟通',
    },
    {
      icon: 'MeetingLogo',
      name: 'WPS 会议',
      desc: '沉浸式智能会议室',
    },
    {
      icon: 'MailLogo',
      name: 'WPS 邮箱',
      desc: '超轻量智能邮箱',
    },
  ],
};

export const secureData = {
  title: '全面护航学校数据安全',
  subtitle: '从端到云全链路保障学校字资产安全',
  list: [
    {
      icon: secure_cloud,
      name: '文档创作即上云',
      desc: '从本地创作源头管控，确保敏感数据安全无虞。',
      tag: '自动入库学校',
    },
    {
      icon: secure_info,
      name: '云端文档不落地',
      desc: '灵活管控下载、外发权限，严防文档外泄。',
      tag: '权限灵活管控',
    },
    {
      icon: secure_lock,
      name: '实体落地可加密',
      desc: '文档下载自动加密，灵活权限回收保障文档安全。',
      tag: '下载自动加密',
    },
    {
      icon: secure_share,
      name: '数据流转可追溯',
      desc: '云端操作全面留痕，日志水印追溯外发源头。',
      tag: '日志监控预警',
    },
  ],
};

export const solveData = {
  title: 'WPS 专属智慧平台解决方案',
  subtitle: '全面接入AI，打造学校专属数字化统一入口',
  tab0: [
    {
      title: '一站式智慧教育平台解决方案',
      desc: '覆盖教学、管理全场景的数字化赋能方案。',
      bigImg: solve1_1,
    },
    {
      title: '打破信息孤岛，凝聚团队智慧',
      desc: '文档共创、任务分配、视频会议、协同沟通等深度融合，无需切换多平台。',
      bigImg: solve1_2,
    },
    {
      title: '支持基教、高教',
      desc: '支持WIN、MAC、移动多端定制专属平台。',
      bigImg: solve1_3,
    },
  ],
};

export const abilityData = {
  title: '校园场景服务',
  subtitle: '一站式满足学校、家校多场景诉求',
  tabs: [
    {
      obj: [
        {
          title: '教学教研',
          desc: '个人备课、集体教研、在线听评轻松搞定，智能减负，教学教研更高效。',
          bigImg: ability1_1,
        },
        {
          title: '教务办公',
          desc: '校园审批、信息采集、校园公告，便捷处理学校日常事务，摆脱复杂管理流程，跨部门协作管理更轻松。',
          bigImg: ability1_2,
        },
        {
          title: '家校互联',
          desc: '家校群、作业收集、成绩发放，家校共育更便捷。',
          bigImg: ability1_3,
        },
        {
          title: '人工智能课',
          desc: 'AI实训、师资培训，师生数字化素养更全面。',
          bigImg: ability1_4,
        },
      ],
    },
    {
      obj: [
        {
          title: '智慧科研',
          desc: '科研项目管理、文献助手、论文助手，构建智能化、协同化、高效化的科研创新管理方式。',
          bigImg: ability2_1,
        },
        {
          title: '教务管理',
          desc: '校园活动、协同办公、师生服务助手，无纸化轻松搞定管理难题。',
          bigImg: ability2_2,
        },
        {
          title: '教学实训',
          desc: 'AI实训、WPS办公技能实训，全面提升师生数字化素养。',
          bigImg: ability2_3,
        },
      ],
    }
  ],
};

export const aiData = {
  title: 'AI助力教与学',
  subtitle: '创新教学方法，师生减负增效的密码',
  list: [
    {
      title: 'AI助管',
      desc: '轻松搭建学校专属知识库、智能客服助手，支持自定义到学校官网、自建应用；智能分析校园运营数据，为管理者提供决策参考。',
      bigImg: ai1_1,
    },
    {
      title: 'AI助教',
      desc: '面向教师教学场景，辅助提升课堂效率与个性化教学能力；精准匹配新课标及教材知识教案、课件生成有的放矢。',
      bigImg: ai1_2,
    },
    {
      title: 'AI助研',
      desc: '说课讲义，自动生成教研过程数据，AI数据处理与分析，助力提升科研效率与深度。',
      bigImg: ai1_3,
    },
    {
      title: 'AI助评',
      desc: '教案、说课、课堂，AI辅助质量分析；作文作业，智能评阅；轻松实现更客观、全面的评估体系。',
      bigImg: ai1_4,
    },
  ],
};

export const serviceData = {
  title: '专属服务',
  subtitle: '全方位的服务，让院校对接更轻松',
  list: [
    {
      icon: service1_1,
      name: '量身定制',
      desc: '为您量身定制高效教学、办公新体验，教学教研、教务管理、沟通协作等，直观且便捷地呈现在眼前。',
    },
    {
      icon: service1_2,
      name: '多种交付方式提供',
      desc: '一站式交付+组件式交付，满足学校不同场景需求。',
    },
    {
      icon: service1_3,
      name: '教师队伍素养培训',
      desc: '专业的解决方案培训和实训服务，助力教师轻松掌握信息化素养提升秘诀。',
      tag: '下载自动加密',
    },
  ],
};

export const customData = {
  title: 'WPS 365教育版助力更多院校实现数智化转型',
};
